import { AnswerEnvironmentState, MgState } from '@types';

export const answerEnvironmentSelector = (store: MgState): AnswerEnvironmentState =>
  store?.answerEnvironment;
